export default function Logo({ size = 44, showText = true }) {
  return (
    <div className="brand brand-aurora" data-testid="lumine-logo">
      <img src="/lumine-symbol.svg" width={size} height={size} className="brand-symbol" alt={showText ? '' : 'Lumine'} />
      {showText && <div className="brand-wordmark">
        <div className="brand-name">lumine<span className="brand-period">.</span></div>
        <div className="brand-caption">CLAREZA QUE TRANSFORMA</div>
      </div>}
    </div>
  );
}
